import { brandImagesPrefix, rebrandImageUrls } from '~/utils/brandImages'

const WRAPPED = Symbol.for('tripening.brandImages')

// Wrap $fetch (and every instance made with $fetch.create, e.g. useApi) so API responses carry
// image URLs on this site's host. No-op on Tripening itself.
function wrapFetch(fetcher: any, prefix: string): any {
    if (fetcher[WRAPPED]) return fetcher
    const wrapped: any = (request: any, options?: any) =>
        fetcher(request, options).then((data: any) => rebrandImageUrls(data, prefix))
    wrapped.raw = async (request: any, options?: any) => {
        const response = await fetcher.raw(request, options)
        response._data = rebrandImageUrls(response._data, prefix)
        return response
    }
    wrapped.native = fetcher.native
    wrapped.create = (...args: any[]) => wrapFetch(fetcher.create(...args), prefix)
    wrapped[WRAPPED] = true
    return wrapped
}

export default defineNuxtPlugin(() => {
    const prefix = brandImagesPrefix(useRuntimeConfig().public.baseURL)
    if (prefix) {
        globalThis.$fetch = wrapFetch(globalThis.$fetch, prefix)
    }
})
